<template>
  <van-icon :name="
    updateColor == '2'?'static/imgs/shoucang_red.png'
    :updateColor == '3'?'static/imgs/shoucang_black.png':'static/imgs/shoucang_gray.png'" size="22"
    @click="goCollection" />
</template>

<script>
import { collect, cancelCollect, getCollectStatus } from "@/request/home";
import eventBus from '@/utils/eventbus.js';
export default {
  props: {
    iconColor: {
      type: String,
      default: "1"
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },//分享传递的参数
    collected: {
      type: Boolean,
      default: false
    },
    collectId: {
      type: String,
      default: ""
    },
    collectType: {
      type: Number,
      default: 0
    }
  },
  watch: {
    collectId: {
      handler (val) {
        this.collectId = val
        if (this.collectId) {
          this.requestGetCollectionStatus()
        }
      },
      immediate: true
    },
  },
  data () {
    return {
      originalColor: '',
      hasCollected: false,
      updateColor: '',
    }
  },
  mounted () {
    this.originalColor = this.iconColor
    this.hasCollected = this.collected
    this.updateColor = this.iconColor
    if (this.collectId) {
      this.requestGetCollectionStatus()
    }
  },
  beforeDestroy () {
    eventBus.$emit('collect_update', this.collectId, this.hasCollected);
  },
  methods: {
    getCollectState() {
      return this.hasCollected;
    },
    requestGetCollectionStatus () {
      if (!this.getUserId()) {
        return
      }
      let params = {
        id: this.collectId,
        userId: this.getUserId()
      }
      getCollectStatus(params).then(res => {
        if (res.code == 0) {
          this.hasCollected = res.data.isCollect
          if (this.hasCollected) {
            this.updateColor = '2'
          } else {
            this.updateColor = this.originalColor
          }
        }
      })
    },
    goCollection () {
      if (this.hasCollected) {
        // 取消收藏
        let params = {
          "id": this.collectId,
          userId: this.getUserId()
        }
        cancelCollect(params).then(res => {
          if (res.code == 0) {
            this.$toast('取消收藏成功')
            this.requestGetCollectionStatus()
          } else {
            this.$toast(res.msg)
          }
        })
      } else {
        // 收藏
        let params = {
          "collectContentId": this.collectId,
          "contentType": this.collectType,
          "userId": this.getUserId()
        }
        collect(params).then(res => {
          if (res.code == 0) {
            this.$toast('收藏成功')
            this.requestGetCollectionStatus()
          } else {
            this.$toast(res.msg)
          }
        })
      }
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/collection/index.vue